var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--burger_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--burger_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.872 13.707c-.332 0-.616-.111-.852-.334a1.07 1.07 0 01-.353-.805v-1.82h12.667v1.82c0 .314-.118.582-.354.805-.235.223-.52.334-.852.334H2.872zm-.205-2.012v.873c0 .056.019.103.057.139a.206.206 0 00.148.054h10.256c.06 0 .11-.018.148-.054a.184.184 0 00.058-.14v-.872H2.667zM8 9.015c-.396 0-.705.105-.927.315-.223.21-.62.316-1.19.316-.572 0-.965-.106-1.18-.316-.217-.21-.523-.315-.918-.315-.396 0-.705.105-.928.315-.222.21-.62.316-1.19.316V8.7c.396 0 .705-.105.927-.315.223-.21.62-.316 1.19-.316.572 0 .965.105 1.181.316.216.21.521.315.917.315s.705-.105.928-.315c.222-.21.62-.316 1.19-.316.571 0 .968.105 1.19.316.223.21.532.315.928.315s.7-.105.911-.315c.212-.21.603-.316 1.174-.316.57 0 .976.105 1.217.316.24.21.545.315.914.315v.946c-.572 0-.96-.106-1.164-.316-.205-.21-.505-.315-.9-.315-.396 0-.711.105-.945.315-.234.21-.636.316-1.207.316-.57 0-.968-.106-1.19-.316-.223-.21-.532-.315-.928-.315zM1.667 6.966v-.51c0-1.098.533-1.951 1.6-2.557 1.066-.607 2.644-.91 4.733-.91 2.089 0 3.667.303 4.733.91 1.067.606 1.6 1.459 1.6 2.558v.51H1.668zM8 3.935c-1.557 0-2.786.182-3.686.546-.9.364-1.428.877-1.586 1.54h10.544c-.157-.663-.686-1.176-1.586-1.54-.9-.364-2.129-.546-3.686-.546z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--burger-23570fc0c38ff2ee1761bc2f030900bb.svg";
export { SvgIconUiBurger as Component };